import bootstrap from 'bootstrap';

class QuickExit {
    exitBtn: HTMLElement;

    constructor(){
        this.init();
    }

    init(){
        this.exitBtn = document.getElementById('quickExit');
        const currentURL = window.location.pathname;
        
        //pages to include quick exit btn
        const pages = [
            "report-discrimination", "sexual-assault-and-violence", "counselling", "crisis-support",
            "self-help-tools-and-resources", "drug-safety-and-harm-reduction", "wellness-at-sait"
        ];

        if(this.exitBtn){
            const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
            const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))
            const button = this.exitBtn.querySelector('a.btn')

            if(pages.includes(currentURL.substring(currentURL.lastIndexOf('/') + 1))){
                //only show button on certain pages
                this.exitBtn.classList.remove('d-none');
            }

            button.addEventListener('click', (e) => {
                e.preventDefault();
                clearPage();
                
                window.open("https://www.google.com/", "_parent");
                window.open("https://www.bbc.com/weather", "_blank").focus();
            })
        }

        function clearPage(){
            //clear elements on current page incase of slow load
            const html = document.getElementsByTagName('html')[0];
            const bodies = document.getElementsByTagName('body');
            const heads = document.getElementsByTagName('head');
            clearAttrs(html);
            
            for(let i = 0; i < bodies.length; ++i) {
                let b = bodies[i];
                clearChildren(b);
                clearAttrs(b);
            }

            for(let i = 0; i < heads.length; ++i) {
                let h = heads[i];
                clearChildren(h);
                clearAttrs(h);
            }

            if(heads.length > 0) {
                var t = document.createElement('title');
                t.innerText = "SAIT - Southern Alberta Institute of Technology";
                heads[0].appendChild(t);
            }

            if(window.history) {
                try {
                    window.history.replaceState({}, '', '/');
                } catch(e) {
                    
                }
            }
        }

        function clearAttrs(elem) {
            while(elem.attributes.length > 0) {
                elem.removeAttribute(elem.attributes[0].name);
            }
        }
    
        function clearChildren(elem) {
            while(elem.firstChild) { 
                elem.removeChild(elem.firstChild) 
            }
        }
       


    }
}

export default QuickExit;